import * as moment from "moment";

export const showFile = (blob: Blob) => {
  const newBlob = new Blob([blob], { type: "application/pdf" });
  if (window.navigator && (window.navigator as any).msSaveOrOpenBlob) {
    (window.navigator as any).msSaveOrOpenBlob(newBlob);
    return;
  }
  const data = window.URL.createObjectURL(newBlob);
  const link = document.createElement("a");
  document.body.appendChild(link);
  link.href = data;
  const dateNow = moment().format("Do-MMM-YY_HH-mm");
  link.download = `print_kudos_${dateNow}`;
  link.target = "_self";
  link.click();
  setTimeout(() => {
    window.URL.revokeObjectURL(data);
  }, 100);
};
